import { render, staticRenderFns } from "./MyProtocol2.vue?vue&type=template&id=6e9c0179&scoped=true"
import script from "./MyProtocol2.vue?vue&type=script&lang=js"
export * from "./MyProtocol2.vue?vue&type=script&lang=js"
import style0 from "./MyProtocol2.vue?vue&type=style&index=0&id=6e9c0179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c0179",
  null
  
)

export default component.exports